import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../Context/ShopContext';
import { useParams } from 'react-router';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';

const Product = () => {
  const { all_product, setAll_Product } = useContext(ShopContext);
  const { productId } = useParams();

  const [dynamicProduct, setDynamicProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const product = all_product.find(
    (e) => e.id === Number(productId) && e.parentId === null
  );

  useEffect(() => {
    if (!product) {
      // Ha nincs a contextben, lekérjük az adott terméket a szerverről
      fetch(`/api/product/${productId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data && data.id) {
            setDynamicProduct(data);
            setAll_Product((prev) => [...prev, data]); // ⬅️ hozzáadjuk a contexthez
          }
        })
        .catch((err) => {
          console.error("Termék lekérés hiba:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [productId, product, setAll_Product]);

  if (loading) {
    return <p style={{ textAlign: 'center', marginTop: '50px' }}>⏳ Betöltés...</p>;
  }

  const selectedProduct = product || dynamicProduct;

  if (!selectedProduct) {
    return <p style={{ textAlign: 'center', marginTop: '50px' }}>❌ Termék nem található.</p>;
  }

  return (
    <>
      <ProductDisplay product={selectedProduct} />
      <DescriptionBox product={selectedProduct} />
      <RelatedProducts productId={productId} />
    </>
  );
};

export default Product;
